

import useIsMobile from '../Utility/useIsMobile'

import { Outlet } from 'react-router-dom'
import { NavLink } from 'react-router-dom'
import usePrefetchUserRecipe from '../features/recipes/hooks/usePrefetchUserRecipe'
import usePrefetchLikedRecipe from '../features/recipes/hooks/usePrefetchLikedRecipes'
import useHoverPrefetch from '../Hooks/useHoverPrefetch'

const tabs=[
{tab:"profile",path:''},
 {tab:"recipes",path:'recipes'},
  {tab:"Liked",path:'liked-recipes'},
   {tab:"settings",path:'settings'}
  
]
export default function Profile() {

    const{prefetchUserRecipe}=usePrefetchUserRecipe()
    const {prefetchLikedRecipe}=usePrefetchLikedRecipe()
    const {handleHover}=useHoverPrefetch(prefetchUserRecipe)
    const {handleHover:handleHoverLiked}=useHoverPrefetch(prefetchLikedRecipe)

    const isMobile=useIsMobile()
  const handleMouseEnter=(tab)=>{
    if(tab==="recipes"){
      handleHover(1)
    }
    if(tab==="Liked"){
      handleHoverLiked(1)
    }
  }
  const handleClick=(tab)=>{
    if(isMobile && tab==="recipes"){
 prefetchUserRecipe(1)
    }
    if(isMobile && tab==="Liked"){
     prefetchLikedRecipe(1)
    }
      
  }
  return (
  <section className='min-h-screen  py-24 bg-[#06070d] text-white'>
    <div className='max-w-7xl mx-auto'>
          <div className="flex overflow-x-auto gap-3 mb-8 px-4 border-b border-white/10 pb-6">
  
   {tabs.map(({ tab, path }) => (
  <NavLink
    key={tab}
    to={path ? `/profile/${path}` : "/profile"}
    onClick={() => handleClick(tab)}
    onMouseEnter={() => handleMouseEnter(tab)}
    end={tab === "profile"}
    className={({ isActive }) =>
      `px-3 sm:px-5 py-2 text-sm sm:text-base rounded-full font-semibold transition ${
        isActive
          ? "bg-orange-500 text-black"
          : "bg-white/5 text-white hover:border-orange-400 border border-white/10"
      }`
    }
  >
    {tab.charAt(0).toUpperCase() + tab.slice(1)}
  </NavLink>
))}
  </div>
    </div>
<Outlet></Outlet>

  </section>
  )
}
